import BottomSheet from '../BottomSheet/BottomSheet';
import '../../styles/RegenerateChoiceModal.css';

/**
 * Replace-vs-Add choice modal shown when regenerating a protocol that already
 * has saved entries. Presentational/stateless — all generate logic stays in the
 * parent. `onChoose` is called with 'replace' or 'add'.
 *
 * Props:
 *   onClose  – called when the modal is dismissed without a choice
 *   onChoose – called with 'replace' | 'add' after the modal animates closed
 */
function RegenerateChoiceModal({ onClose, onChoose }) {
    return (
        <BottomSheet onClose={onClose} className="regenerate-choice-modal" zIndex={10000}>
            {({ onClose: handleClose }) => (
                <>
                    <div className="modal-header">
                        <h2>Update protocol</h2>
                        <button className="close-btn" onClick={handleClose} aria-label="Close modal">×</button>
                    </div>
                    <div className="modal-body">
                        <p className="regenerate-choice-copy">
                            Your manual additions and dose edits are always kept. Choose how to
                            apply the freshly generated recommendations.
                        </p>
                        <button
                            type="button"
                            className="regenerate-choice-btn regenerate-choice-btn--primary"
                            data-testid="regenerate-replace"
                            onClick={() => { handleClose(); onChoose('replace'); }}
                        >
                            Replace previous protocol
                        </button>
                        <button
                            type="button"
                            className="regenerate-choice-btn regenerate-choice-btn--secondary"
                            data-testid="regenerate-add"
                            onClick={() => { handleClose(); onChoose('add'); }}
                        >
                            Add to existing
                        </button>
                    </div>
                </>
            )}
        </BottomSheet>
    );
}

export default RegenerateChoiceModal;
